export default /\.(com|me)$/;



// WEBPACK FOOTER //
// ./src/utils/parseDomain/tld.js